import { COLORS } from '@/constants';
import { Button } from '@mui/material';
import styled from 'styled-components';

export const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  gap: 8px;
  min-width: 550px;

  background-color: ${COLORS.white};
  color: ${COLORS['gray-dark']};
  border-radius: 8px;
  overflow: hidden;
  transform: translateZ(0);

  box-shadow: 0px 5px 8px 0px #391f151a;

  @media (max-width: 800px) {
    min-width: 0;
    width: 100%;
  }
`;

export const Img = styled.div`
  min-width: 200px;
  max-width: 282px;
  max-height: 310px;
  align-self: stretch;
  max-height: 310px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left;
    display: block;
  };

  @media (max-width: 800px) {
    max-height: none;
    max-width: 123px;
    min-width: 123px;
    flex-shrink: 0;
    max-height: 400px;
  }
`;

export const CardBox = styled.div`
  display: flex;
  gap: 15px;
  flex-direction: column;
  max-width: 312px;
  padding: 30px 0px 30px 35px;

  @media (max-width: 800px) {
    flex: 1;
    min-width: 0;
    width: 100%;
    max-width: none;
    padding: 24px 12px 24px 24px;
    gap: 12px;
  }
`;

export const StyledButton = styled(Button)<{
  $color: keyof typeof COLORS;
  $borderColor: keyof typeof COLORS;
}>`
  && {
    width: fit-content;
    color: ${(props) => COLORS[props.$color]};
    border-color: ${(props) => COLORS[props.$borderColor]};
    background-color: transparent;
    border-width: 2px;
    border-radius: 6px;
    padding: 8px 20px;
    height: 38px;
  }
`;
